import { all, fork } from 'redux-saga/effects';

import { ServicePickerWidgetSagas } from '../../ServicePickerWidget';

export function* rootSaga() {
  yield all([...ServicePickerWidgetSagas].map(fork));
}
